export default {
    routes: [
        {
            path: '/modules',
            name: 'modules.index',
            component: () => import('./views/Index.vue'),
            meta: {
                label: 'Modules',
                permission: 'manage-modules',
                auth: true,
            },
            children: [
                {
                    path: ':moduleId/form-schema',
                    name: 'modules.form-schema.index',
                    component: () => import('./views/form-schema/Index.vue'),
                    meta: {
                        label: 'Form Schema',
                        permission: 'manage-vocus',
                    },
                    children: [
                                                
                    ]
                },
            ]
        }
    ]
}
